module.exports = __webpack_public_path__ + "static/media/cta_invite_group_chat.378d584e.svg";